import { Addon, ApiConfig } from '../../limitPrivateAPI';
import { PrivateAPINamespace } from '../PrivateAPINamespace';

@ApiConfig(Addon)
export class AccessibilityNamespace extends PrivateAPINamespace {
  static readonly namespace = 'accessibility';

  async getSkipToContent(): Promise<boolean> {
    return this.ps.ds.accessibility.skipToContent.get();
  }

  async setSkipToContent(
    appDefinitionId: string,
    value: boolean,
  ): Promise<void> {
    this.ps.ds.runInContext(appDefinitionId, () =>
      this.ps.ds.accessibility.skipToContent.set(value),
    );
    await this.ps.ds.waitForChangesAppliedAsync();
  }

  async getVisualFocus(): Promise<boolean> {
    return this.ps.ds.accessibility.visualFocus.get();
  }

  async setVisualFocus(appDefinitionId: string, value: boolean): Promise<void> {
    this.ps.ds.runInContext(appDefinitionId, () =>
      this.ps.ds.accessibility.visualFocus.set(value),
    );
    await this.ps.ds.waitForChangesAppliedAsync();
  }

  async getAutoDomReorder(): Promise<boolean> {
    return this.ps.ds.accessibility.autoDomReorder.get();
  }

  async setAutoDomReorder(
    appDefinitionId: string,
    value: boolean,
  ): Promise<void> {
    this.ps.ds.runInContext(appDefinitionId, () =>
      this.ps.ds.accessibility.autoDomReorder.set(value),
    );
    await this.ps.ds.waitForChangesAppliedAsync();
  }
}
